import React, { useState, useEffect, useCallback } from 'react';
import './MemoriesView.css';

function MemoriesView({ userId, apiBase }) {
  const [memories, setMemories] = useState([]);
  const [loading, setLoading] = useState(true);

  const loadMemories = useCallback(async () => {
    try {
      const response = await fetch(`${apiBase}/memories?user_id=${userId}&limit=20`);
      const data = await response.json();
      setMemories(data.memories || []);
    } catch (err) {
      console.error('Failed to load memories:', err);
    } finally {
      setLoading(false);
    }
  }, [userId, apiBase]);

  useEffect(() => {
    loadMemories();
  }, [loadMemories]);

  if (loading) {
    return <div className="memories-view">⏳ Загружаю твои моменты...</div>;
  }

  if (memories.length === 0) {
    return (
      <div className="memories-view">
        <div className="empty-state">
          <p>📭 У тебя ещё нет сохранённых моментов</p>
          <p>Начни писать впечатления - они будут здесь! ✨</p>
        </div>
      </div>
    );
  }

  return (
    <div className="memories-view">
      <h2>💭 Твои хорошие моменты</h2>
      <p className="memories-subtitle">Вспоминай их, когда грустно</p>

      <div className="memories-list">
        {memories.map((memory) => (
          <div key={memory.id} className="memory-card">
            <div className="memory-header">
              <span className="memory-emoji">{memory.emoji || '✨'}</span>
              <span className="memory-date">{formatDate(memory.created_at)}</span>
            </div>

            <p className="memory-text">{memory.text}</p>

            <div className="memory-reward">💰 +{memory.reward} монет</div>

            {memory.keywords && memory.keywords.length > 0 && (
              <div className="memory-keywords">
                {memory.keywords.map((kw, idx) => (
                  <span key={idx} className="keyword-tag">{kw}</span>
                ))}
              </div>
            )}
          </div>
        ))}
      </div>

      <div className="memories-tip">
        <p>🌟 Просматривай эти моменты, когда нужна поддержка. Они - доказательство того, что в жизни есть хорошее!</p>
      </div>
    </div>
  );
}

function formatDate(dateString) {
  try {
    const date = new Date(dateString);
    const today = new Date();
    const yesterday = new Date(today);
    yesterday.setDate(yesterday.getDate() - 1);

    if (date.toDateString() === today.toDateString()) {
      return 'Сегодня ' + date.toLocaleTimeString('ru-RU', { hour: '2-digit', minute: '2-digit' });
    }
    if (date.toDateString() === yesterday.toDateString()) {
      return 'Вчера';
    }

    return date.toLocaleDateString('ru-RU', { day: 'numeric', month: 'short' });
  } catch {
    return 'Когда-то';
  }
}

export default MemoriesView;
